import { apiService } from "../../../utils/api/api.service";
import { requestWithErrorHandling } from "../../../utils/error/handle.error";
import type {
  NotificationPreferenceResponse,
  NotificationPreferenceScope,
  NotificationPreferencesMap,
} from "../interfaces/notificationPreferences.interface";

class NotificationPreferencesService {
  private static instance: NotificationPreferencesService;

  static getInstance(): NotificationPreferencesService {
    if (!NotificationPreferencesService.instance) {
      NotificationPreferencesService.instance = new NotificationPreferencesService();
    }
    return NotificationPreferencesService.instance;
  }

  private endpointFor(scope: NotificationPreferenceScope): string {
    return scope === "admin"
      ? "/admin/settings/notification-preferences"
      : "/notification-preferences";
  }

  getPreferences = (scope: NotificationPreferenceScope) => {
    return requestWithErrorHandling(async () => {
      return await apiService.get<NotificationPreferenceResponse>(
        this.endpointFor(scope),
      );
    });
  };

  savePreferences = (
    scope: NotificationPreferenceScope,
    preferences: NotificationPreferencesMap,
  ) => {
    return requestWithErrorHandling(async () => {
      return await apiService.put<NotificationPreferenceResponse>(
        this.endpointFor(scope),
        { preferences },
      );
    });
  };
}

export const notificationPreferencesService =
  NotificationPreferencesService.getInstance();
